// extracted by mini-css-extract-plugin
export default {"textError":"Error_textError__Nxupb","errorContainer":"Error_errorContainer__KWCPm","cross":"Error_cross__vuS8R"};